import gql from 'graphql-tag';

const UPDATE_SHOPPER_NOTIFICATIONS = gql`  
    mutation updateShopperNotification($input: ShopperNotificationInput) {
        updateShopperNotification(input: $input) {
            internalCode
        }
    }
`;

export default UPDATE_SHOPPER_NOTIFICATIONS;
